module.exports = __webpack_public_path__ + "img/qq.c4ecd750.svg";